// extracted by mini-css-extract-plugin
export var heroImage = "_ji-1";
export var modal = "_ji-0";